import { useCallback } from "react";
import useEmblaCarousel from "embla-carousel-react";
// import { recentMilestonesData } from "utils/home-page-data";
// import MoreButton from "./MoreButton";
import { motion,AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { randomExtension,formatDate } from "utils/utils";
import profile from "pages/profile/profile";


const milestoneRequestCache = {};

const animation = {
  initial: { opacity: 0, translateY: 25 },
  whileInView: { opacity: 1, translateY: 0 },
  transition: { duration: 0.5 },
};

export default function RecentMilestoneSection() {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    dragFree: true,
    loop: false,
  });

  const {t} = useTranslation();
  const [milestones,setMilestone] = useState([]);

  const scrollPrev = useCallback(() => emblaApi?.scrollPrev(), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi?.scrollNext(), [emblaApi]);
  const showButtons = true;


  const { http } = global.services; 
  
  
    const fetchNotifications = async () => {  
        // key/ID of the cache
            const cacheKey = randomExtension();
          try {
            let data = {};
            let milestones = [];
            
            if(milestoneRequestCache[cacheKey]) {
                  // get the data from cache object
                  data = milestoneRequestCache[cacheKey];
              } else {
                  // if no cache found then request it
              const { data: result } = await http.get("milestone/display");

                (result || []).forEach((item)=>{
                  milestones.push({
                    id:item.id,
                    name: `${item.profile?.user?.first_name} ${item.profile?.user?.last_name}`,
                    profile_photo: item?.profile?.profile_image_url,
                    title: item.title,
                    photo:item.thumbnail?.webp_url || item.thumbnail?.url,
                    date:formatDate(item,true,t),
                    profile:item.profile,
                    hash_id:item.hash_id
                  });
                })
                
              data = milestones;
              setMilestone(milestones);
              }
             
              if(!milestoneRequestCache[cacheKey]) {
                  milestoneRequestCache[cacheKey] = data;
              }
              
          } catch (err) {
            console.log(err);
        
          }finally {  
        }
      }
  
    useEffect(()=>{
        fetchNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const viewMilestone = (item)=>{
      const extension = randomExtension();
      console.log(item)
      const {hash_id,profile} = item;
      const urlView = `${process.env.REACT_APP_PUBLIC_DOMAIN}/${profile?.user?.username}-${extension}/profile/${profile.id}?milestone=${hash_id}`;
      window.open(urlView, "_blank");
    }

  return (
    <div className="pt-[3.75rem] pb-[3.75rem] px-6">
      <motion.h1
        {...animation}
        className="text-center font-medium text-3xl md:text-5xl mb-9"
      >
        {t('recentlyAddedMilestones')}
      </motion.h1>

      <div className="container m-auto flex flex-col gap-8">
        <motion.div className="w-full max-w-[88rem] mx-auto" {...animation}>
          {showButtons && (
            <>
              <div className="flex flex-row items-center gap-4 mb-4 px-2 justify-end">
                <button
                  onClick={scrollPrev}
                  className="border-[1.5px] border-onbg rounded-full w-10 h-10 flex items-center justify-center cursor-pointer transition-all duration-325 hover:bg-primary hover:text-white hover:border-primary outline-none"
                >
                  <svg
                    width="8"
                    height="12"
                    viewBox="0 0 8 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.06211 1.1001L2.15206 5.01015C1.60533 5.55688 1.60532 6.44331 2.15206 6.99005L6.06211 10.9001"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
                <button
                  onClick={scrollNext}
                  className="border-[1.5px] border-onbg rounded-full w-10 h-10 flex items-center justify-center cursor-pointer transition-all duration-325 hover:bg-primary hover:text-white hover:border-primary outline-none"
                >
                  <svg
                    width="7"
                    height="12"
                    viewBox="0 0 7 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.1625 1.1001L5.07255 5.01015C5.61928 5.55688 5.61928 6.44331 5.07255 6.99005L1.1625 10.9001"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </button>
              </div>
            </>
          )}

          <div ref={emblaRef} className="overflow-hidden">
            <div className="flex gap-6">
              {
                milestones.length > 0 ?
                milestones.map((item) => (
                <div
                  key={item.id}
                  className="bg-bgvariant-2 min-h-[28.5rem] w-[20.5rem] rounded-lg flex-shrink-0 select-none cursor-pointer transform transition duration-300 ease-in-out hover:scale-105"
                  data-role="recent-item"
                  onClick={()=>viewMilestone(item)}
                >
                  <div className="w-full h-[4.25rem] px-5 py-4 flex flex-row items-center">
                    <div className="w-9 h-9 rounded-full bg-black/10 mr-3 flex items-center justify-center overflow-hidden">
                      <img src={item.profile_photo} alt="profile_image"/>
                    </div>
                    <div className="text-xl font-bold">{item.name}</div>
                    <div className="ml-1">
                      {/* <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M8.34047 15.5599H7.54172L5.66297 13.6249H2.88422L2.28797 13.0624V10.3399L0.386719 8.40492V7.60617L2.28797 5.67117V2.93742L2.88422 2.37492H5.66297L7.54172 0.451172H8.34047L10.2755 2.37492H13.0092L13.5717 2.92617V5.67117L15.4955 7.60617V8.40492L13.538 10.3399V13.0624L12.9755 13.6249H10.2755L8.34047 15.5599ZM6.48422 10.7899H7.28297L11.5242 6.54867L10.7255 5.74992L6.88922 9.59742L5.33672 8.04492L4.53797 8.84367L6.48422 10.7899Z"
                          fill="#0C6ED1"
                        />
                      </svg> */}
                    </div>
                  </div>
                  <div className="relative bg-transparent h-auto 2md:min-h-[325px] 2md:w-[325px] overflow-hidden">
                    
                    <div className="relative flex items-center justify-center h-full w-full">
                        <img src={item.photo} alt="recent_item" className="w-full 2md:w-[325px] h-[325px] object-cover"/>
                    </div>
                  </div>
                  <div className="px-5 py-[1.125rem] flex flex-col">
                    <div className="text-base font-medium leading-[1.4] line-clamp-2">
                      {item.title}
                    </div>
                    <div className="font-bold text-sm text-primary">
                        {item.date}
                    </div>
                  </div>
                </div>
              )):
              <div className="flex w-full">
                <div className="w-full">
                  <Skeleton/>
                  <Skeleton/>
                </div>
                <div className="w-full">
                  <Skeleton/>
                  <Skeleton/>
                </div>
                <div className="w-full">
                  <Skeleton/>
                  <Skeleton/>
                </div>
                <div className="w-full">
                  <Skeleton/>
                  <Skeleton/>
                </div>
              </div>
              }
              
            </div>
          </div>
        </motion.div>
      </div>

      {/* <motion.div
        {...animation}
        className="flex items-center justify-center mt-9"
      >
        <MoreButton>{t('exploreMoreMilestones')}</MoreButton>
      </motion.div> */}
    </div>
  );
}


const Skeleton = ()=>{
  return(
    <div class="mx-auto w-full max-w-3xl rounded-md p-4">
      <div class="flex animate-pulse space-x-4">
        <div class="size-10 rounded-full bg-gray-200"></div>
        <div class="flex-1 space-y-6 py-1">
          <div class="h-2 rounded bg-gray-200"></div>
          <div class="space-y-3">
            <div class="grid grid-cols-3 gap-4">
              <div class="col-span-2 h-2 rounded bg-gray-200"></div>
              <div class="col-span-1 h-2 rounded bg-gray-200"></div>
            </div>
            <div class="h-2 rounded bg-gray-200"></div>
          </div>
        </div>
      </div>
    </div>
  )
}
